//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['mapSelectindex', 'netSelectindex', 'roadSelectindex', 'tabList', 'selectIndex', 'labelState'],
  methods: {
    onselectMap: function onselectMap() {
      this.$emit('onselectMap');
    },
    onselectNet: function onselectNet() {
      this.$emit('onselectNet');
    },
    onselectRoad: function onselectRoad() {
      this.$emit('onselectRoad');
    },
    OntoTab: function OntoTab(val) {
      this.$emit('OntoTab', val);
    },
    onToChangeLabel: function onToChangeLabel() {
      this.$emit('onToChangeLabel');
    }
  }
};